import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import { RootState, rootReducer } from './index';
import { systemInitialState } from '../pods/system/state/reducer';
import { practitionerInitialState, userInitialState } from 'src/pods/user/state/reducer';
import { sessionInitialState } from '../pods/sessions/state/reducer';
import { onboardingInitialState } from 'src/pods/onboarding/state/reducers';

// eslint-disable-next-line
const composeEnhancers = (window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const createStoreWithMiddleware = composeEnhancers(applyMiddleware(thunk))(createStore);

// eslint-disable-next-line
export default function configureStore(initialState: RootState): any {
    return createStoreWithMiddleware(rootReducer, initialState);
}

export function getInitialState(): RootState {
    const _initState: RootState = {
        systemReducer: systemInitialState,
        userReducer: userInitialState,
        practitionerReducer: practitionerInitialState,
        sessionReducer: sessionInitialState,
        onboardingReducer: onboardingInitialState,
    };
    return _initState;
}
